/* 3 Tree Official — homepage interactions (namespaced, additive) */
(function () {
  'use strict';
  function initReveal() {
    var els = document.querySelectorAll('.tt-reveal:not(.in)');
    function revealAll() { els.forEach(function (el) { el.classList.add('in'); }); }
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: never let a section stay hidden if the observer misses it.
    setTimeout(revealAll, 1600);
  }
  function initToggles() {
    document.querySelectorAll('[data-tt-toggle]').forEach(function (group) {
      if (group.dataset.ttBound) return; group.dataset.ttBound = '1';
      group.addEventListener('click', function (e) {
        var b = e.target.closest('[aria-pressed]');
        if (!b || !group.contains(b)) return;
        group.querySelectorAll('[aria-pressed]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
      });
    });
  }
  function initMenu() {
    document.querySelectorAll('[data-tt-menu-open]').forEach(function (b) {
      if (b.dataset.ttBound) return; b.dataset.ttBound = '1';
      b.addEventListener('click', function () { document.body.classList.add('tt-menu-open'); });
    });
    document.querySelectorAll('[data-tt-menu-close]').forEach(function (b) {
      if (b.dataset.ttBound) return; b.dataset.ttBound = '1';
      b.addEventListener('click', function () { document.body.classList.remove('tt-menu-open'); });
    });
  }
  function initSearch() {
    document.querySelectorAll('[data-tt-search-open]').forEach(function (b) {
      if (b.dataset.ttSo) return; b.dataset.ttSo = '1';
      b.addEventListener('click', function () {
        document.body.classList.add('tt-search-open');
        var i = document.querySelector('[data-tt-search-input]');
        if (i) setTimeout(function () { i.focus(); }, 90);
      });
    });
    document.querySelectorAll('[data-tt-search-close]').forEach(function (b) {
      if (b.dataset.ttSc) return; b.dataset.ttSc = '1';
      b.addEventListener('click', function () { document.body.classList.remove('tt-search-open'); });
    });
  }
  function initAutosubmit() {
    document.querySelectorAll('[data-tt-autosubmit]').forEach(function (el) {
      if (el.dataset.ttAs) return; el.dataset.ttAs = '1';
      el.addEventListener('change', function () { if (el.form) el.form.submit(); });
    });
  }
  function initEscape() {
    if (document.body.dataset.ttEsc) return; document.body.dataset.ttEsc = '1';
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.body.classList.remove('tt-search-open', 'tt-menu-open');
    });
  }
  function boot() { initReveal(); initToggles(); initMenu(); initSearch(); initAutosubmit(); initEscape(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // Theme editor re-init
  document.addEventListener('shopify:section:load', boot);
})();
